import isEmpty from 'lodash/isEmpty';
import { SectionNumber, SECTIONS } from '../constants';
import { PageNumber, SectionInfo, SectionPage, SectionNumberObj } from '../interfaces';
import { PGSectionNumber, PG_SECTIONS } from '../providerGroups/constants';

export const calculateProgress = <Sect extends SectionNumber | PGSectionNumber>(
  sectionValue: Sect,
  section: SectionNumberObj<Sect>,
  pageNumber: PageNumber = 0,
  customPages?: Map<number, SectionPage>
): number => {
  const sections: Map<SectionNumber | PGSectionNumber, SectionInfo> =
    section === PGSectionNumber ? PG_SECTIONS : SECTIONS;
  let currentSection = sections.get(sectionValue);
  const nextSection = sections.get(sectionValue + 1);
  if (!currentSection) return 0;
  if (!isEmpty(customPages)) {
    currentSection = { ...currentSection, pages: customPages };
  }
  if (!currentSection.pages || !nextSection) return currentSection.startingProgress;
  let deltaToNext = nextSection.startingProgress - currentSection.startingProgress;
  if (!nextSection) {
    deltaToNext = 100 - currentSection.startingProgress;
  }
  const progressMadeInCurrent = (pageNumber / currentSection.pages.size) * deltaToNext;

  return currentSection.startingProgress + progressMadeInCurrent;
};
